export const FOLDER_COLORS = ["#ef4444", "#f97316", "#f59e0b", "#eab308", "#22c55e", "#14b8a6", "#06b6d4", "#3b82f6", "#6366f1", "#a855f7", "#ec4899", "#64748b"];

// Selettore colore di sfondo cartella: preset + colore personalizzato + nessuno.
export default function FolderColorPicker({ value, onChange, testId = "folder-color" }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testId}s`}>
      <button type="button" onClick={() => onChange("")} data-testid={`${testId}-none`} title="Nessun colore"
        className={`h-7 px-2 rounded-md border text-[11px] ${!value ? "border-amber-500 text-amber-500" : "border-slate-600 text-slate-400"}`}>Nessuno</button>
      {FOLDER_COLORS.map((c) => (
        <button key={c} type="button" onClick={() => onChange(c)} data-testid={`${testId}-${c.slice(1)}`} title={c}
          style={{ backgroundColor: c }} className={`h-7 w-7 rounded-md border-2 transition-transform hover:scale-110 ${value === c ? "border-slate-900 ring-2 ring-amber-400" : "border-transparent"}`} />
      ))}
      <input type="color" value={value || "#f59e0b"} onChange={(e) => onChange(e.target.value)} data-testid={`${testId}-custom`} title="Colore personalizzato"
        className="h-7 w-9 cursor-pointer rounded border border-slate-600 bg-transparent" />
    </div>
  );
}
